'use client';

import { useLegacyServerData } from '@/components/providers/LegacyServerDataProvider';
import { Nullable } from '@/components/types';
import React, { useContext } from 'react';

export type NextPayoutContextData = {
  eventNextPayoutDate?: string;
  eventNextPayoutType?: string;
};

export type NextPayoutContextProviderProps = {
  children: React.ReactNode;
};

export const NextPayoutContext = React.createContext<Nullable<NextPayoutContextData>>(null);

export const NextPayoutContextProvider: React.FC<NextPayoutContextProviderProps> = ({
  children,
}) => {
  const legacyServerData = useLegacyServerData();
  const value = {
    eventNextPayoutDate: legacyServerData?.eventNextPayoutDate,
    eventNextPayoutType: legacyServerData?.eventNextPayoutType,
  };
  return <NextPayoutContext.Provider value={value}>{children}</NextPayoutContext.Provider>;
};

export const useNextPayoutContext = () => {
  return useContext(NextPayoutContext) as NextPayoutContextData;
};
